import { useState } from 'react';
import { api } from '../api';
import { HubSignIn, useAuthMode } from '../HubSignIn';
import { Field, LoadingPanel } from '../ui/bits';

export function Login({ onLogin }: { onLogin: () => void }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const authMode = useAuthMode();

  if (authMode === null) return <LoadingPanel />;
  if (authMode.mode === 'hub' && authMode.hubBaseUrl) {
    return <HubSignIn hubBaseUrl={authMode.hubBaseUrl} onSignedIn={onLogin} title="MHub — ops workspace" />;
  }

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      await api.post('/api/auth/dev-login', { email });
      onLogin();
    } catch {
      setError('Login failed — user must exist (run npm run seed:dev).');
    }
  };

  return (
    <div className="auth-card">
      <h1>MHub — dev sign-in</h1>
      <p className="muted">Session stub mode (local dev only).</p>
      <form onSubmit={submit} className="stack">
        <Field label="Email" error={error}>
          {(id) => (
            <input
              id={id}
              type="email"
              required
              placeholder="you@plaidware.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          )}
        </Field>
        <div>
          <button className="primary" type="submit">
            Sign in
          </button>
        </div>
      </form>
    </div>
  );
}
